'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _themeSections = require('@shopify/theme-sections');

var _validator = require('@yaireo/validator');

var _validator2 = _interopRequireDefault(_validator);

var _micromodal = require('micromodal');

var _micromodal2 = _interopRequireDefault(_micromodal);

var _crumbsjs = require('crumbsjs');

var _crumbsjs2 = _interopRequireDefault(_crumbsjs);

var _getDevice = require('../util/get-device');

var _getDevice2 = _interopRequireDefault(_getDevice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectors = {
  newsletterForm: '[data-newsletter-form]',
  newsletterFooter: '.newsletter__footer',
  newsletterEmailField: '[data-newsletter-email-field]',
  newsletterEmailInput: '[data-newsletter-email-input]',
  newsletterRecaptchaField: '[data-newsletter-recaptcha-field]',
  newsletterRecaptchaElement: '.g-recaptcha-response'
}; /* eslint-env browser */


(0, _themeSections.register)('newsletter', {
  // eslint-disable-next-line require-await
  onLoad: function onLoad() {
    var _this2 = this;

    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this2.formElements = _this2.container.querySelectorAll(selectors.newsletterForm);
              _this2.cookieName = 'newsletter-dismissed';

              _this2.validator = new _validator2.default({
                texts: {
                  empty: window.theme.strings.forms.empty,
                  checked: window.theme.strings.forms.acceptPrivacy,
                  email: window.theme.strings.forms.invalidEmail
                }
              });

              _this2.onBlurFieldValidation = _this2.onBlurFieldValidation.bind(_this2);
              _this2.onInputFieldValidation = _this2.onInputFieldValidation.bind(_this2);

              _this2.formValidation = _this2.formValidation.bind(_this2);

              _this2.formElements.forEach(function (formElement) {
                formElement.addEventListener('blur', _this2.onBlurFieldValidation);
                formElement.addEventListener('input', _this2.onInputFieldValidation);
                formElement.onsubmit = _this2.formValidation;
              });

              if (_this2.isModal()) {
                _this2.maybeShowModal();
              }

              _this2.onEmailInputFocus = _this2.onEmailInputFocus.bind(_this2);
              _this2.emailInputs = _this2.container.querySelectorAll(selectors.newsletterEmailInput);
              _this2.emailInputs.forEach(function (emailInput) {
                emailInput.addEventListener('focus', _this2.onEmailInputFocus);
              });

              setTimeout(function () {
                _this2.newsletterRecaptchaElements = _this2.container.querySelectorAll(selectors.newsletterRecaptchaElement);
                _this2.newsletterRecaptchaElements.forEach(function (el) {
                  el.required = true;
                });
              }, 1000);

              if ((0, _getDevice2.default)() === 'mobile') {
                if (_this2.isModal()) {
                  _this2.centerModal();
                }
              }

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },
  testClick: function testClick() {
    alert();
  },
  onBlurFieldValidation: function onBlurFieldValidation(event) {

    var field = event.target;
    // do not execute on checkboxes
    if (field.getAttribute('type') === 'checkbox') {
      return;
    }
    var fieldWrap = field.closest('.field');
    var result = this.validator.checkField(field);

    if (!fieldWrap) {
      return;
    }

    if (result.valid) {
      fieldWrap.classList.add('good');
    } else {
      fieldWrap.classList.remove('good');
    }
  },
  onInputFieldValidation: function onInputFieldValidation(event) {

    var field = event.target;
    var fieldWrap = field.closest('.field');
    var result = this.validator.checkField(field);

    if (!fieldWrap) {
      return;
    }

    if (result.valid) {
      fieldWrap.classList.add('good');
    } else {
      fieldWrap.classList.remove('good');
    }
  },
  formValidation: function formValidation(event) {
    var validatorResult = this.validator.checkAll(event.srcElement);
    event.preventDefault();

    var valid = Boolean(validatorResult.valid);
    var parent = document.querySelector('.modal--newsletter');
    var modalRecaptchaField = document.querySelector('.modal--newsletter div[data-newsletter-recaptcha-field]');
    var modalRecaptchaMsg = document.querySelector('.modal--newsletter .captchaMsg');
    var recaptcha = validatorResult.fields.find(function (item) {
      return item.field.className === 'g-recaptcha-response';
    });

    // Check if forms are inside modal
    if (parent && parent.contains(event.srcElement)) {
      // Check if recaptcha is not complete, getResponde return if recaptcha is complete or empty, 1 is for the second recaptcha in Page
      if (grecaptcha.getResponse(1) === '') {
        // add errors inside the correct form
        modalRecaptchaField.classList.add('bad');
        modalRecaptchaMsg.innerHTML = window.theme.strings.forms.acceptRecaptcha;
        recaptcha.valid = false;
      } else {
        recaptcha.valid = true;
        modalRecaptchaField.classList.add('good');
        modalRecaptchaMsg.innerHTML = '';

        if (valid) {
          this.submit(event.srcElement);
        }

        return valid;
      }
    } else {
      // Check if recaptcha is not complete, getResponde return if recaptcha is complete or empty, 0 is for the first recaptcha in Page, recaptcha in dynamic block
      // eslint-disable-next-line
      if (grecaptcha.getResponse(0) === '') {
        // add errors inside the correct form
        document.querySelector('.captchaMsg').parentNode.classList.add('bad');
        document.querySelector('.captchaMsg').innerHTML = window.theme.strings.forms.acceptRecaptcha;
        recaptcha.valid = false;
      } else {
        recaptcha.valid = true;
        document.querySelector('.captchaMsg').parentNode.classList.add('good');
        document.querySelector('.captchaMsg').innerHTML = '';

        if (valid) {
          this.submit(event.srcElement);
        }

        return valid;
      }
    }
  },
  submit: function submit(formElement) {
    var _this3 = this;

    this.showElement('newsletter__loading');
    var formData = new FormData(formElement);
    var requestOptions = {
      method: 'POST',
      body: formData,
      redirect: 'follow'
    };

    fetch(formElement.action, requestOptions).then(function (response) {
      return response.text();
    }).then(function (result) {
      var data = JSON.parse(result);
      _this3.hideElement('newsletter__loading');

      if (data.status === 'ok') {
        _this3.showSuccess(data);
      } else if (data.status === 'error') {
        _this3.addAlert(selectors.newsletterEmailField, data.error.message);
      }
    }).catch(function (error) {
      _this3.hideElement('newsletter__loading');
      console.error(error);
      _this3.addAlert(selectors.newsletterEmailField, 'Unknown error: ' + error);
    });
  },
  showSuccess: function showSuccess(data) {

    if (data.subscription === 'alreadySubscribed') {
      this.addAlert(selectors.newsletterEmailField, window.theme.strings.newsletter.alreadySubscribed);
    } else {
      this.hideElement('newsletter__form-wrap');
      this.showElement('newsletter__success');
      if (data.customer === 'returning') {
        this.showElement('newsletter__success__message__returning');
      } else {
        this.showElement('newsletter__success__message__new');
      }
    }
  },
  onEmailInputFocus: function onEmailInputFocus() {
    this.showElement('newsletter__footer');
  },
  showElement: function showElement(baseClass) {
    var element = this.container.querySelector('.' + baseClass);
    if (element.classList.contains(baseClass + '--hidden')) {
      element.classList.remove(baseClass + '--hidden');
    }
  },
  hideElement: function hideElement(baseClass) {
    var element = this.container.querySelector('.' + baseClass);
    if (!element.classList.contains(baseClass + '--hidden')) {
      element.classList.add(baseClass + '--hidden');
    }
  },
  addAlert: function addAlert(fieldSelector, message) {
    var alertElement = document.createElement('div');
    alertElement.classList.add('alert');
    alertElement.innerHTML = message;
    var field = this.container.querySelector(fieldSelector);
    field.classList.add('bad');
    field.classList.remove('good');
    field.appendChild(alertElement);
  },
  maybeShowModal: function maybeShowModal() {

    _micromodal2.default.init();
    var delay = (this.container.dataset.modalDelay || 5) * 1000;
    // eslint-disable-next-line consistent-this
    var _this = this;

    var expirationDays = parseInt(this.container.dataset.expirationDays, 10);

    if (this.container.dataset.modalForce || !this.newsletterDismissed()) {
      setTimeout(function () {
        _micromodal2.default.show('modal-newsletter');
        _crumbsjs2.default.set(_this.cookieName, 1, { type: 'day', value: expirationDays }, '/');

        var modalContainer = _this.container.querySelector('[data-modal-container]');
        _this.onClickModal = _this.onClickModal.bind(_this);
        modalContainer.addEventListener('click', _this.onClickModal);
      }, delay);
    }
  },
  onClickModal: function onClickModal() {
    var modal = this.container.querySelector('#modal-newsletter');
    if (!modal.classList.contains('modal-clicked')) {
      modal.classList.add('modal-clicked');
    }
  },
  isModal: function isModal() {
    return this.container.dataset.sectionSubtype && this.container.dataset.sectionSubtype === 'newsletter-modal';
  },
  newsletterDismissed: function newsletterDismissed() {
    return _crumbsjs2.default.get(this.cookieName);
  },
  centerModal: function centerModal() {
    var modal = this.container.querySelector('#modal-newsletter');
    var delay = (this.container.dataset.modalDelay || 5) * 1000;

    if (modal.classList.contains('modal-centered')) {
      setTimeout(function () {
        modal.classList.add('modal-clicked');
      }, delay);
    }
  }
});